/*
  Arma el listado de "Mis Favoritos" en el navegador.

  Lee los handles guardados en localStorage (misma key que favorites.js),
  pide los datos de cada producto via la Ajax API de Shopify
  (GET /products/{handle}.js -- publica, no requiere cuenta) y renderiza
  una tarjeta por producto usando el <template> definido en
  sections/favorites-list.liquid.

  Si un handle ya no corresponde a un producto real (borrado o
  despublicado), se omite del listado y se limpia de localStorage para
  que no se siga intentando cargar en cada visita.
*/
(function () {
  const STORAGE_KEY = window.FAVORITES_STORAGE_KEY || "balentes_favorites";

  function readFavorites() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error("No se pudieron leer los favoritos guardados.", e);
      return [];
    }
  }

  function writeFavorites(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      console.error("No se pudo actualizar la lista de favoritos.", e);
    }
  }

  // Formateador de precio -- replica el patron money_format de la tienda
  // (window.theme.moneyFormat, ej. "{{amount_with_comma_separator}} €")
  // en vez de asumir un formato fijo. Sin esto los precios salian en
  // formato "€1090.00" (ingles) en una pagina que esta en /es-es/.
  function formatWithDelimiters(cents, decimals, thousands, decimalSep) {
    if (isNaN(cents)) return "";
    const value = (cents / 100).toFixed(decimals);
    const parts = value.split(".");
    const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return decimals > 0 ? intPart + decimalSep + parts[1] : intPart;
  }

  function formatMoney(cents) {
    const format = (window.theme && window.theme.moneyFormat) || "€{{amount}}";
    let value;
    if (format.indexOf("amount_no_decimals_with_comma_separator") !== -1) {
      value = formatWithDelimiters(cents, 0, ".", ",");
    } else if (format.indexOf("amount_with_comma_separator") !== -1) {
      value = formatWithDelimiters(cents, 2, ".", ",");
    } else if (format.indexOf("amount_no_decimals") !== -1) {
      value = formatWithDelimiters(cents, 0, ",", ".");
    } else {
      value = formatWithDelimiters(cents, 2, ",", ".");
    }
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
  }

  // Prefijo de idioma actual (ej. "/es-es") para pedir el producto en el
  // mismo idioma en el que esta la pagina de favoritos, en vez de caer al
  // idioma por defecto de la tienda.
  const LOCALE_PREFIX = (location.pathname.match(/^\/[a-z]{2}-[a-z]{2}(?=\/)/) || [""])[0];

  async function fetchProduct(handle) {
    const res = await fetch(`${LOCALE_PREFIX}/products/${handle}.js`);
    if (!res.ok) return null;
    return res.json();
  }

  function buildCard(template, product) {
    const node = template.content.firstElementChild.cloneNode(true);
    const link = node.querySelector("[data-favorites-card-link]");
    const image = node.querySelector("[data-favorites-card-image]");
    const title = node.querySelector("[data-favorites-card-title]");
    const price = node.querySelector("[data-favorites-card-price]");
    const removeBtn = node.querySelector("[data-favorites-card-remove]");

    link.href = product.url;
    image.src = product.featured_image || (product.images && product.images[0]) || "";
    image.alt = product.title;
    title.textContent = product.title;
    price.textContent = formatMoney(product.price);
    removeBtn.dataset.productHandle = product.handle;

    removeBtn.addEventListener("click", (event) => {
      event.preventDefault();
      const current = readFavorites().filter((h) => h !== product.handle);
      writeFavorites(current);
      // Mantiene sincronizados los corazones de otras tarjetas/paginas
      // si favorites.js ya esta cargado en esta misma pagina.
      if (window.favoritesManager) {
        window.favoritesManager.favorites = current;
        window.favoritesManager.updateButtons(product.handle, false);
        window.favoritesManager.updateHeaderCount();
      }
      node.remove();
      if (!grid.children.length) toggleEmptyState(true);
    });

    return node;
  }

  let grid, emptyState, loadingState;

  function toggleEmptyState(isEmpty) {
    if (emptyState) emptyState.hidden = !isEmpty;
    if (grid) grid.hidden = isEmpty;
  }

  async function init() {
    grid = document.querySelector("[data-favorites-grid]");
    emptyState = document.querySelector("[data-favorites-empty]");
    loadingState = document.querySelector("[data-favorites-loading]");
    const template = document.querySelector("[data-favorites-card-template]");
    if (!grid || !template) return;

    const handles = readFavorites();

    if (!handles.length) {
      if (loadingState) loadingState.hidden = true;
      toggleEmptyState(true);
      return;
    }

    const results = await Promise.all(
      handles.map(async (handle) => {
        try {
          return await fetchProduct(handle);
        } catch (e) {
          return null;
        }
      })
    );

    const validHandles = [];
    results.forEach((product, i) => {
      if (product) {
        grid.appendChild(buildCard(template, product));
        validHandles.push(handles[i]);
      }
    });

    // Limpia handles de productos que ya no existen.
    if (validHandles.length !== handles.length) {
      writeFavorites(validHandles);
      if (window.favoritesManager) window.favoritesManager.favorites = validHandles;
    }

    if (loadingState) loadingState.hidden = true;
    toggleEmptyState(validHandles.length === 0);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();